
import {DigitizationTools} from "../ToolRegistry.js";
import {runPerpendicularCapture} from "./perpendicularCapture.js";

import {T} from "../i18n/index.js";
// "Vinkelret linje": digitize a baseline, then register a chain of points
// each individually constrained (in XY) perpendicular to the relevant
// baseline segment, connected in the order they're captured into a single
// LineString - see tools/perpendicularCapture.js for the shared capture flow
// and geometry/perpendicularConstraint.js for the projection/constraint
// math. Deliberately NOT a constant-offset tool: each point's distance from
// the baseline is whatever the user picks, independently. The baseline and
// every preview visual are pure construction geometry and are discarded once
// the result line is finished - only the result line persists.
export const PerpendicularLineTool = {
	id: "digitize_perpendicular_line",
	name: T("Vinkelret linje"),
	category: "specialized",
	kind: "registration",
	toolbarGroup: "registration",
	toolbarOrder: 110,
	icon: "perpendicular_line.svg",
	resultGeometryType: "LineString",
	featureType: T("Vinkelret linje"),

	tooltip: T("Digitalisér først en basislinje. Registrér derefter flere punkter vinkelret på basislinjen. Punkterne forbindes til en linje."),

	instructions: {
		baseline: T("Basislinje: Venstreklik for at placere punkter langs basislinjen. Højreklik for at afslutte basislinjen."),
		perpendicular: T("Vælg positioner i punktskyen - hvert punkt fastlåses vinkelret på basislinjen. Venstreklik for at gemme et punkt, højreklik for at afslutte linjen (mindst 2 punkter)."),
	},

	customCapture(dm, tool){
		runPerpendicularCapture(dm, tool, "line");
	},
};

DigitizationTools.register(PerpendicularLineTool);
